import * as React from 'react';

import { EInputMode } from '../types';

export const DefaultInputModeContext = React.createContext<EInputMode>(EInputMode.Address);

export const DefaultInputModeContextProvider = DefaultInputModeContext.Provider;
